<template>
    <Loading v-bind:show="showLoading">
        <PageTitle title="Fies - Aditamento" />
        <div v-if="!showLoading && $featureToggle && $featureToggle.INTEGRA_FIES_BASEFULL">
            <div v-if="dadosAba.cpf" class="md-layout content-dados">
                <div class="md-layout-item md-size-50">
                    <md-list class="md-double-line md-dense">
                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4" v-formatdate="dadosAba.dataAtualizacao"></span>
                                <span class="s-h3 regular">Última atualização</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.tipoFies}}</span>
                                <span class="s-h3 regular">Tipo FIES</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.situacao}}</span>
                                <span class="s-h3 regular">Situação do FIES</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.grupo}}</span>
                                <span class="s-h3 regular">Grupo</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.subGrupo}}</span>
                                <span class="s-h3 regular">SubGrupo</span>
                            </div>
                        </md-list-item>

                        <!--<md-list-item>
                        <div class="md-list-item-text mostrarMaisMenos">
                            <span>
                                {{dadosAba.orientacao}}
                            </span>
                            <span>Limite Crédito - PAM</span>
                        </div>
                    </md-list-item>-->
                    </md-list>
                </div>
                <div class="md-layout-item md-size-50">
                    <md-list class="md-double-line md-dense">

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.resposavelAcao}}</span>
                                <span class="s-h3 regular">Responsável pela Ação</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.alunoMatriculado}}</span>
                                <span class="s-h3 regular">Aluno Matriculado</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4" v-if="dadosAba.pendencia != ''">{{dadosAba.pendencia}}</span>
                                <span v-else>-</span>
                                <span class="s-h3 regular">Pendência Acadêmica</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div v-bind:class="[exibirTudo ? 'mostrarMaisMenos' : '']" class="md-list-item-text">
                                <span class="s-h4">{{dadosAba.acao}}</span>
                                <div class="block-mostrarMais s-h4">
                                    <span class="s-h3 regular">Ação</span>
                                    <span v-on:click="mostrarMaisMenos" class="link-mostrarMais">
                                        {{mostrarMaisMenosTexto}}
                                    </span>
                                </div>
                            </div>
                        </md-list-item>

                    </md-list>
                </div>
            </div>
            <div v-else>
                <md-empty-state class="content"
                                md-icon="block"
                                md-label="Nenhum registro encontrado"
                                md-description="O aluno não possui FIES Aditado.">
                </md-empty-state>
            </div>
        </div>
    </Loading>
</template>

<script>
    import Loading from '@/components/Loading';
    import FiesService from '@/services/FiesService.js';
    import { formatdate } from '@/directives/formatdate.js';
    import PageTitle from '@/components/PageTitle';

    export default {
        name: 'Fies',
        components: {
            Loading,
            PageTitle
        },
        data() {
            return {
                dadosAba: null,
                showLoading: false,
                exibirTudo: false,
                mostrarMaisMenosTexto: "MOSTRAR MAIS",
            }
        },
        directives: {
            formatdate,
        },
        created() {
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);

                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.Fies) {
                        this.dadosAba = a.Fies;
                    }
                }
                else
                    this.$router.push('home');
            }

            this.fiesService = new FiesService(this);

            if (this.$featureToggle.INTEGRA_FIES_BASEFULL) {
                //Verifica se a aba não está carregada
                if (!this.dadosAba) {
                    //Popula os dados da aba
                    this.showLoading = true;
                    this.fiesService.ConsultarFiesAditamento({
                        Cpf: this.aluno.cpf
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosAba = data.dados.fiesAditamento;
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoading = false;
                        });
                }
            }
            else {
                this.$modal.alert(this.$msgFeatureToggle);
            }
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.Fies = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        methods: {
            mostrarMaisMenos() {
                if (this.exibirTudo) {
                    this.exibirTudo = false;
                    this.mostrarMaisMenosTexto = "MOSTRAR MAIS";
                }
                else {
                    this.exibirTudo = true;
                    this.mostrarMaisMenosTexto = "MOSTRAR MENOS";
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .content {
        margin-top: 2rem;
        margin: 0 auto;
    }

    .content-dados {
        margin: 2rem;
    }

    .mostrarMaisMenos {
        white-space: normal;
    }

    .block-mostrarMais {
        display: flex;
        justify-content: space-between;
    }

    .link-mostrarMais {
        padding: 0;
        width: 160px;
        margin-top: 3px;
        text-align: right;
        color: #448aff !important;
        cursor: pointer;
        font-size: 12px !important;
    }

    .link-mostrarMais:hover {
        opacity: 0.7;
    }

    .rotated {
        transform: rotate(180deg);
    }
</style>
